import styled from 'styled-components/macro'
import { Box, Typography } from '@material-ui/core'
import { CloseModalIcon } from 'common/icon-components/CloseModalIcon'

export type Size = 'sm' | 'md' | 'lg'

const getModalBodySize = (size?: Size) => {
  switch (size) {
    case 'sm':
      return '40%'
    case 'md':
      return '65%'
    case 'lg':
      return '90%'
    default:
      return '90%'
  }
}

const renderBorderColor = (color: string) => {
  switch (color) {
    case 'primary':
      return '#7E45C4'
    default:
      return '#B4BDCA'
  }
}

//@ts-ignore
export const TopBox = styled(Box) <{noborder: string, borderColor: string}>`
border-bottom:${props => (props.noborder === 'true' ? 'none' : `1px solid ${renderBorderColor(props.borderColor)} !important;`)};
  @media screen and (max-width: ${props => props.theme.breakpoints.medium}) {
    border-bottom: ${props => (props.borderColor === 'default' ? 'none !important' : `1px solid ${renderBorderColor(props.borderColor)} !important;`)};
  }
`
export const GreyCloseIcon = styled(CloseModalIcon)`
  color: darkGrey;
  transform: scale(1);
`
export const Title = styled(Typography)`
  && {
    font-size: 1rem;
    font-weight: 900;
    color: #494b57;
  }
`

export const DialogInner = styled.div<{noMargin?: boolean, backgroundColor?: string}>`
  outline: none;
  /* max-width: 540px; */
  
  width: auto;
  height: auto;
  padding: ${props => props.noMargin ? "0" :"0 1.5em 1.5em 1.5em"};
  font-size: 0.75rem;
  border-radius: 15px;
  background-color: ${props => props.backgroundColor || props.theme.colors.supplementary};
  @media screen and (max-width: ${props => props.theme.breakpoints.medium}) {
    width: 100%;
  }
`

export const ModalInner = styled.div<{ size?: Size }>`
  outline: none;
  max-width: ${props => (props.size === 'lg' ? '100%' : getModalBodySize(props.size))};
  width: 100%;
  font-size: 0.75rem;
  height: ${props => getModalBodySize(props.size)};
  border-radius: 6px;
  display: grid;
  grid-template-areas:
    'title'
    'body';
  @media screen and (max-width: ${props => props.theme.breakpoints.medium}) {
    margin-top: 0;
    margin-left: 0;
    padding: 0;
  }
`
export const StyledDialogBox = styled(Box)`
  && {
    padding-bottom: 15px;
  }
`